import { Interface } from '@ethersproject/abi'
import { ChainId } from '@uniswap/sdk'
import V1_EXCHANGE_ABI from './v1_exchange.json'
import V1_FACTORY_ABI from './v1_factory.json'

const V1_FACTORY_ADDRESSES: any = {
  80002: '0x5703733Bc869fd43E0649B92834815D39aA8b4A0', // 0xcE15835777ccc944D532604bEF3232Db382FfE18 TODO: DO NOT SUPPORT V1 ON MUMBAI
  [ChainId.MATIC]: '0x74b1c2b3B6E349aCC674Fb350BA34Bdb549c27F2', //0x03F66CD52F7399bCA0722eF284928EFbE52A7768
}

const V1_FACTORY_INTERFACE = new Interface(V1_FACTORY_ABI)
const V1_EXCHANGE_INTERFACE = new Interface(V1_EXCHANGE_ABI)

export { V1_FACTORY_ADDRESSES, V1_FACTORY_INTERFACE, V1_FACTORY_ABI, V1_EXCHANGE_INTERFACE, V1_EXCHANGE_ABI }
